var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._t("visible")],2)}
var staticRenderFns = []

export { render, staticRenderFns }